import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faEdit, faExchangeAlt,faGlobe, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import UserProfile from './UserProfile';
import ChangePassword from './ChangePassword';
import UpdateLogo from './UpdateLogo'
import PaymentTransactionTableList from './PaymentTransactionTableList';
import './index.scss';
import { useDispatch, useSelector } from "react-redux";
import { roleItems } from "../../../utils/constants";
import UserTimezone from '../AccountSettingTab/UserTimezone';
import { updateTimezone } from "../../../context/actions/user";
// import PlanDetail from './PlanDetail';

const AccountSettingTab = ({ _plan, _trans, _subscription }) => {
    const [activeTab, setActiveTab] = useState('1');
    const userDetail = useSelector((state) => state?.user?.user);
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }
    const [selectedTimeZone, setSelectedTimeZone] = useState(null);

    const handleTimeZoneSelect = (timezone) => {
        setSelectedTimeZone(timezone);
    };

    const dispatch = useDispatch()
    const onSubmit = (data) =>{
        // console.log(data)
        let dataobj = {
            timezone : data,
            isTimezoneSet : true
        }
        dispatch(
            updateTimezone(dataobj, (res) => {
                console.log(res)
            })
          )
    }

    return (
        <div className='tab-wrapper card'>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => { toggle('1'); }}
                    >
                        <span>
                            <FontAwesomeIcon icon={faUser} />
                        </span>
                        Profile
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => { toggle('2'); }}
                    >
                        <span>
                            <FontAwesomeIcon icon={faLock} />
                        </span>
                        Change Password
                    </NavLink>
                </NavItem>
                {/* Time zone tab */}
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === '5' })}
                        onClick={() => { toggle('5'); }}
                    >
                        <span>
                            <FontAwesomeIcon icon={faGlobe} />
                        </span>
                        Time Zone Preference
                    </NavLink>
                </NavItem>
                {/* Time zone tab */}
                {/* {userDetail?.role !== roleItems[1] && (
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '3' })}
                            onClick={() => { toggle('3'); }}
                        >
                            <span>
                                <FontAwesomeIcon icon={faEdit} />
                            </span>
                            Update Logo
                        </NavLink>
                    </NavItem>
                )} */}
                <NavItem>
                    {/* <NavLink
                        className={classnames({ active: activeTab === '4' })}
                        onClick={() => { toggle('4'); }}
                    >
                        <span>
                            <FontAwesomeIcon icon={faExchangeAlt} />
                        </span>
                        Transactions
                    </NavLink> */}
                </NavItem>
                {/* <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === '5' })}
                        onClick={() => { toggle('5'); }}
                    >
                        <span>
                            <FontAwesomeIcon icon={faCircleInfo} />
                        </span>
                        Plan Detail
                    </NavLink>
                </NavItem> */}
            </Nav>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <UserProfile />
                </TabPane>
                <TabPane tabId="2">
                    <ChangePassword />
                </TabPane>
                {userDetail?.role !== roleItems[1] && (
                    <TabPane tabId="3">
                        <UpdateLogo />
                    </TabPane>)}
                <TabPane tabId="5">
                    <UserTimezone selectedTimeZone={selectedTimeZone} onSubmit={onSubmit} onSelect={handleTimeZoneSelect}/>
                </TabPane>
                <TabPane tabId="4">
                    <PaymentTransactionTableList _plan={_plan} _trans={_trans} _subscription={_subscription} />
                </TabPane>
                {/* <TabPane tabId="5">
                    <PlanDetail/>
                </TabPane> */}
            </TabContent>
        </div>
    );
}

export default AccountSettingTab;